"use client"

import TEBreadcrumb from "@/components/common/TEBreadcrumb"
import { useToursCategories } from "@/hooks/tour/useToursCategories"
import { faHomeAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useParams } from "next/navigation"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

type TourCategoryBreadcrumbProps = {
  className?: string
}

const TourCategoryBreadcrumb = ({ className }: TourCategoryBreadcrumbProps) => {

  const params = useParams()
  const { data: { tourCategories } } = useToursCategories()
  const { t } = useTranslation()

  const selectedCategory = useMemo(() => {
    if (params?.categoryId && !!tourCategories?.length) {
      return tourCategories?.find(tourCategory => tourCategory.id === params?.categoryId)
    }
    return null
  }, [params?.categoryId, tourCategories?.length])

  return (
    <TEBreadcrumb
      className={["tour-category-page__breadcrumb", className].filter(Boolean).join(" ")}
      items={[
        {
          path: "/tours",
          title: (
            <>
              <FontAwesomeIcon icon={faHomeAlt} />
              <span>
                {t("common.home")}
              </span>
            </>
          ),
        },
        {
          path: `/tours/category${selectedCategory?.id}`,
          title: (
            <>
              <span>
                {selectedCategory?.name || ''}
              </span>
            </>
          ),
        }
      ]}
    />
  )
}

export default TourCategoryBreadcrumb